// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedKeratoscopyElevation_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6.88589 14.9458C9.05179 16.0287 11.1824 16.6579 12.7162 17.1003L12.871 17.1449C13.4391 17.3087 13.9021 17.4421 14.2515 17.5632 13.5563 17.8449 12.7963 18 12 18 9.72236 18 7.74114 16.7309 6.72489 14.8613 6.77797 14.8905 6.83164 14.9187 6.88589 14.9458ZM14.8503 16.7183C15.0294 16.789 15.2099 16.8712 15.3587 16.9726 16.9524 15.894 18 14.0693 18 12 18 11.7783 17.988 11.5593 17.9645 11.3438 17.7457 11.4502 17.4983 11.5783 17.2216 11.7214 17.0833 11.793 16.9375 11.8684 16.7845 11.9467 15.4484 12.6306 13.6261 13.5016 11.8822 13.5016 10.9525 13.5016 10.0906 13.4141 9.33627 12.9064 8.77804 12.5307 8.32434 11.9568 7.92715 11.1311 7.31589 11.6366 6.56337 11.8707 6.00015 11.9574L6 12C6 12.3732 6.03407 12.7384 6.09927 13.0927 6.46616 13.4956 6.88064 13.8252 7.33309 14.0514 9.40989 15.0898 11.463 15.698 12.9933 16.1395L13.1718 16.1909C13.8491 16.386 14.438 16.5556 14.8503 16.7183Z" class="svg-bg"/>
  <path d="M16.7297 10.8498C17.1048 10.6556 17.4588 10.4723 17.7652 10.3324C17.7033 10.1181 17.6299 9.90881 17.5455 9.70514C17.2032 9.67852 16.8474 9.6158 16.5 9.5C15.5852 9.19506 15.2283 9.07609 14.8622 9.02968C14.628 9 14.3901 9 14 9C13.7418 9 13.5169 9.03331 13.2995 9.06552C12.6751 9.15802 12.1126 9.24133 11 8.49957C9.90339 7.7685 9.60848 8.37359 9.13844 9.33801C8.99737 9.62746 8.84053 9.94927 8.6415 10.277C9.04766 11.2632 9.46085 11.7849 9.89462 12.0768C10.3884 12.4091 10.9917 12.5016 11.8822 12.5016C13.3514 12.5016 14.9689 11.7527 16.3289 11.0566C16.4643 10.9873 16.5983 10.9179 16.7297 10.8498Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M24 12C24 18.6274 18.5097 24 11.8822 24C5.25483 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedKeratoscopyElevation is a generated icon component.
 */
let IconMedKeratoscopyElevation = IconMedKeratoscopyElevation_1 = class IconMedKeratoscopyElevation extends IconBaseElement {
    render() {
        return html `${IconMedKeratoscopyElevation_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedKeratoscopyElevation.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedKeratoscopyElevation = IconMedKeratoscopyElevation_1 = __decorate([
    customElement('zui-icon-med-keratoscopy-elevation')
], IconMedKeratoscopyElevation);
export { IconMedKeratoscopyElevation };
